import { useQuery } from "@tanstack/react-query";
import { SimpleAutocomplete } from "@/model";
import nluRepository from "@/repository/nluRepository";


export const useNluAutocompletes = (agentToken?: string) => {
    return useQuery<SimpleAutocomplete[]>({
        queryKey: ['nlu', 'autocomplete-tokens', agentToken],
        queryFn: async () => {
            if (!agentToken) {
                return [];
            }
            const response = await nluRepository.getAutocompletes(agentToken);
            return response.data;
        },
        enabled: !!agentToken
    });
};
